
import { Component, Input, OnInit,  AfterViewInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {  ToastService, ControlsComponent} from '../../../blocks';
import { UserSessionService, getDateObj } from '../../../shared';
import {  PatientVisitsService } from './../patient-visit.service';
import { PatientVisit } from './../patient-visit';
import { SelectizeComponent } from './../../../blocks/selectize/selectize.component';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { RegPatVisit } from '../../out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
@Component({
    selector: 'sanabel-cancelVisit',
    templateUrl: './cancel-patient-visit.component.html'
})
export class CancelPatVisit implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    @Input() patVisit: PatientVisit;
    moreDatatoggle: boolean = false;
    visitData: any;
    msgDataToggle: boolean = true;

    constructor(
        public translate: TranslateService,
        private _patientVisitsService: PatientVisitsService,
        private _USS: UserSessionService,
        private _toastService: ToastService) {
    }

    onClicked(e: number): void {
        switch (e) {
            case 1: //save code
                this.save();
                break;
            default:
                this.cancel();
        }
    }

    ngOnInit() {
        if (this.patVisit == undefined)
        this.patVisit = <any>{};
        this.getVisit$();
    }
    ngAfterViewInit() {
        this.visitData = this._USS.getModalKey('CancelPatVisit')["inputs"];
          this._getPatVisit(this.visitData['visitSerial']);
    }
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();

    }
    getVisit$() {
        this._USS.getModalKey$().pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((keys: any) => {
                if (keys.name == 'CancelPatVisit' && keys.inputs) {
                    this._getPatVisit(keys.inputs['visitSerial']);
                }
            });
    }
    _getPatVisit(visitNo: number) {
      
        let nextVisitStatus = 3;  // send the next value of VisitStatus of currnet component for specific validation in Case Cancel visit Status Will be = 3
        if (visitNo > 0) {
            this._patientVisitsService.CancelSpecificVisit(visitNo, nextVisitStatus )
                .subscribe(
                (visit) => {
                    if (visit['returnFlag']) {
                        this._setEditPatVisit(visit.data[0]);
                        this.msgDataToggle = true;
                    }else{
                        this._USS.closeModalKey('CancelPatVisit', false);
                    }
                },
                err => console.error(err),
                () => {
                });
        }
    }
   
    private _setEditPatVisit(patVisit: PatientVisit) {
        this.patVisit = patVisit;
    }

    save() {
        this.patVisit.visitStatus = 3;
        this.patVisit.endDate = getDateObj(this.patVisit.endDateNgb) ;
        let patVisit = this.patVisit ;
        delete  patVisit.endDateNgb ;
        this._patientVisitsService.updateSpecificVisit(patVisit)
            .subscribe(res => {
                this._USS.closeModalKey('CancelPatVisit', res.returnFlag);
            }, error => console.log(error)
        );
    }
    cancel(showToast = true) {
        this._USS.closeModalKey('CancelPatVisit', 'Cross click');
    }

}
